import { Animation, AnimationState, Enum } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Animation {
        waitForFinished(animationName?: string): Promise<void>;
        waitForLastFrame(animationName?: string): Promise<void>;
        getClipsEnum(): { [key: string]: number } | null;
    }
}

Animation.prototype.waitForFinished = function waitForFinished(this: Animation, animationName?: string) {
    const targetState = this.getState(animationName);
    if (animationName && !targetState) {
        throw new Error(`Can't find the animation state: ${animationName}`);
    }
    const listener = (callback: () => void) => (_: Animation.EventType, state: AnimationState) => {
        if (targetState && state !== targetState) {
            this.once(Animation.EventType.FINISHED, listener(callback));
            return;
        }
        callback();
    };
    return new Promise((resolve) => this.once(Animation.EventType.FINISHED, listener(resolve)));
};

Animation.prototype.waitForLastFrame = function waitForLastFrame(this: Animation, animationName?: string) {
    const targetState = this.getState(animationName);
    if (animationName && !targetState) {
        throw new Error(`Can't find the animation state: ${animationName}`);
    }
    const listener = (callback: () => void) => (_: Animation.EventType, state: AnimationState) => {
        if (targetState && state !== targetState) {
            this.once(Animation.EventType.LASTFRAME, listener(callback));
            return;
        }
        callback();
    };
    return new Promise((resolve) => this.once(Animation.EventType.LASTFRAME, listener(resolve)));
};

Animation.prototype.getClipsEnum = function getClipsEnum(this: Animation) {
    const enumDef: { [key: string]: number } = { '&lt;None&gt;': 0 };
    let actualIndex = 0;
    for (let i = 0; i < this.clips.length; i++) {
        if (!this.clips[i]) {
            continue;
        }
        const { name } = this.clips[i];
        enumDef[name] = actualIndex + 1;
        actualIndex++;
    }
    return Enum(enumDef);
};
